<template>
  <b-form-group>
    <h6 class="font-size-md">
      <span v-if="isRequired" class="ml-n1 text-danger">*</span>
      {{ label }}
    </h6>
    <div class="input-icon input-icon-sm">
      <b-form-input
        v-model="formValue"
        :placeholder="placeholder"
        :type="inputType"
        :state="isValid ? null : false"
        :size="size"
        class="rounded-pill pr-5"
        :readonly="isReadOnly"
        :disabled="isDisabled"
        @focus="onFocus"
        @blur="onBlur"
      />
      <div v-if="showTool" class="input-icon-group">
        <a href="#" tabindex="-1" @click="show = !show">
          <span class="material-icons font-size-base text-secondary" :class="{'mr-3': !isValid}">{{ show ? 'visibility_off' : 'visibility' }}</span>
        </a>
      </div>
      <div v-if="!isValid" class="invalid-feedback">
        {{ error }}
      </div>
      <div v-if="hint !== ''" class="mt-1 font-size-sm text-gray600">
        {{ hint }}
      </div>
    </div>
  </b-form-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    allowDisplayPassword: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'sm'
    },
    validate: {
      type: Function,
      default() {
        return () => {};
      }
    },
    required: {},
    readonly: {},
    disabled: {}
  },
  data() {
    return {
      formValue: this.value,
      show: false
    };
  },
  computed: {
    isValid() {
      return (this.error || '') === '';
    },
    showTool() {
      return this.type === 'password' && this.allowDisplayPassword;
    },
    inputType() {
      if (this.showTool) {
        return this.show ? 'text' : 'password';
      }

      return this.type;
    },
    isRequired() {
      if (this.required === true) return true;
      if (this.required === false) return false;
      if (this.required === undefined) return false;
      if (this.required === '') return true;
      return false;
    },
    isReadOnly() {
      if (this.readonly === true) return true;
      if (this.readonly === false) return false;
      if (this.readonly === undefined) return false;
      if (this.readonly === '') return true;
      return false;
    },
    isDisabled() {
      if (this.disabled === true) return true;
      if (this.disabled === false) return false;
      if (this.disabled === undefined) return false;
      if (this.disabled === '') return true;
      return false;
    }
  },
  watch: {
    formValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      if (val !== this.formValue) this.formValue = val;
    }
  },
  created() {
  },
  methods: {
    onFocus(e) {
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.$emit('blur', e);
    }
  }
};
</script>
